<div class="bv-data-form">
  <div class="bv-data-form__section">
    <h4 class="bv-data-form__section-title">{{'TABS.GENERAL_INFO' | translate}}</h4>
    <app-individual-form [individualData]="individualData" [IndividualType]="IndividualType"
    (updateDataForm)="updateDataForm($event)"></app-individual-form>
  </div>

  <div class="bv-data-form__section">
    <h4 class="bv-data-form__section-title">{{'INDV.ADDRESS' | translate}}</h4>
    <app-individual-address [individualData]="individualData" [countryCode]="countryCode"
    (updateDataAddress)="updateAddress($event)"></app-individual-address>
  </div>

  <div class="bv-data-form__section">
    <h4 class="bv-data-form__section-title">{{'INDV.ATTACH_DOCS' | translate}}</h4>
    <app-individual-documents [IndividualType]="IndividualType" [IndividualData]="individualData"
      [countryCode]="countryCode" (updateDocumentsFiles)="updateDocuments($event)">
    </app-individual-documents>
  </div>

  <div class="bv-data-form__footer">
    <a class="bv-btn bv-btn--secondary" routerLink="/individuals/list">
      <mat-icon>arrow_back</mat-icon>
      {{'BUTTONS.BACK' | translate}}
    </a>
    <div class="bv-data-form__footer-right">
      @if (individualData && individualData.vinculate_company_id === 0 && IndividualType === 1) {
        <button class="bv-btn bv-btn--secondary" (click)="newSociety()">{{'LABELS.CONVERT_TO' | translate}}</button>
      }
      <button class="bv-btn bv-btn--primary" (click)="updateData(false)"
        [disabled]="isInvalidFormData">
        @if (loadingSave) {
          <mat-icon class="bv-spinner">sync</mat-icon>
        }
        {{'BUTTONS.SAVE' | translate}}
      </button>
    </div>
  </div>
</div>
